import moment from "moment";

/**
 * Formats an Order's calendar date (deliveryDate / pickupDate) for display.
 *
 * The getOrder normalizer stores these as "MM-DD-YYYY" strings. Re-parsing that
 * with a bare `moment(str)` is not a recognized ISO/RFC2822 format, so moment
 * falls back to the JS `Date()` constructor — which Safari/Firefox reject,
 * rendering "Invalid date" on the customer dashboard. Passing the explicit input
 * format keeps parsing deterministic across every browser and timezone.
 *
 * @param date - an "MM-DD-YYYY" calendar date string (or null/empty)
 * @returns localized short date (e.g. "Oct 28, 2026"), or "" when absent/invalid
 */
export const formatOrderDate = (date?: string | null): string => {
  if (!date) return "";
  const parsed = moment(date, "MM-DD-YYYY");
  return parsed.isValid() ? parsed.format("ll") : "";
};
